var root = document.documentElement

var getScrollBarWidth = (function () {
  return {
    init: function () {
      var scrollDiv = document.createElement('div')
      scrollDiv.style.width = '100px'
      scrollDiv.style.height = '100px'
      scrollDiv.style.overflow = 'scroll'
      scrollDiv.style.position = 'absolute'
      scrollDiv.style.top = '-9999px'
      document.body.appendChild(scrollDiv)
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      document.body.removeChild(scrollDiv)
      return scrollbarWidth
    },
  }
})()

if (!videoPopup) {
  var videoPopup = (function () {
    return {
      inited: false,
      init() {
        if (!this.inited) {
          this.inited = true
          this.watchVideoItem()
        }
      },

      watchVideoItem() {
        const videoItems = document.querySelectorAll('[data-video-popup]')
        videoItems.forEach(item => {
          item.addEventListener('click', e => {
            const data = e.currentTarget.dataset
            this.open(data)
          })
        })
      },
      initPopup(content, text) {
        this.modal = new tingle.modal({
          footer: false,
          stickyFooter: false,
          closeMethods: ['overlay', 'button', 'escape'],
          cssClass: ['video-popup'],
          onOpen: function () {
            document.documentElement.classList.add('open-popup')
            root.style.setProperty('padding-right', getScrollBarWidth.init() + 'px')
          },
          onClose: function () {
            document.documentElement.classList.remove('open-popup')
            root.style.removeProperty('padding-right')
          },
          beforeClose: function () {
            document.documentElement.classList.remove('open-popup')
            root.style.removeProperty('padding-right')
            return true
          },
        })
        this.modal.setHeader = function (content) {
          let popup_content = this.modalBoxContent
          let popup_header = document.createElement('div')
          popup_header.classList.add('tingle-modal-box__header')
          popup_header.innerHTML = content
          let parentElement = popup_content.parentNode
          parentElement.insertBefore(popup_header, popup_content)
        }
        if (text) {
          this.modal.setHeader(text)
        }

        this.modal.setContent(content)
        this.modal.open()
      },
      // --aspect-ratio-mb:3/5;
      // <img src="${poster}" class="video-popup-poster" alt="Video poster" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; background: #000;" />
      open(data) {
        const isMobile = window.innerWidth < 768
        const poster = (isMobile && data.posterMobile) || data.poster
        const html = `<div
      class="relative w-full inset-0 cover-bg video-popup-wrapper"
      style="--tingle-padding: 0;--aspect-ratio: 16/9;--bg:url(${poster})"
    >
      
      ${this.generatePopupContent(data.type, data)}
    </div>`
        if (!html) return
        this.initPopup(html)
        
        /* 注释掉视频加载后隐藏封面图的逻辑 */
        /* setTimeout(() => {
          const posterImg = document.querySelector('.video-popup-poster')
          const mediaItem = document.querySelector('.media-item')
          if (mediaItem && posterImg) {
            if (mediaItem.tagName === 'VIDEO') {
              mediaItem.addEventListener('loadeddata', () => {
                posterImg.style.display = 'none'
              })
            } else if (mediaItem.tagName === 'IFRAME') {
              setTimeout(() => {
                posterImg.style.display = 'none'
              }, 1000)
            }
          }
        }, 100) */
      },
      onClose() {
        this.modal.close()
      },

      generatePopupContent(type, data) {
        if (type === 'video') {
          const isMobile = window.innerWidth < 768
          const source = (isMobile && data.sourceMobile) || data.source
          const poster = (isMobile && data.posterMobile) || data.poster
          return `<video
        class="rounded media-item"
        loop="true"
        playsinline="true"
        autoplay="true"
        controls="true"
        src="${source}"
        poster="${poster}"
      ></video>`
        } else if (type === 'youtube') {
          return `<iframe
        src="https://www.youtube.com/embed/${data.videoId}?enablejsapi=1&disablekb0&autoplay=1&mute=1&loop=1&controls=1&rel=0&playsinline=1"
        class="js-youtube fs-0 w-full media-item"
        frameborder="0"
        allowfullscreen
      ></iframe>`
        } else if (type === 'vimeo') {
          return `<iframe
        class="js-vimeo fs-0 w-full media-item"
        src="https://player.vimeo.com/video/${data.videoId}?autoplay=1&muted=1&loop=1&controls=0"
        frameborder="0"
        allowfullscreen
      ></iframe>`
        }
      },
    }
  })()
  videoPopup.init()
}
